import { render, staticRenderFns } from "./PixieEditor.vue?vue&type=template&id=d8833bd8&"
import script from "./PixieEditor.vue?vue&type=script&lang=js&"
export * from "./PixieEditor.vue?vue&type=script&lang=js&"
import style0 from "./PixieEditor.vue?vue&type=style&index=0&id=d8833bd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports